import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { DropdownType, getBorderStyleData } from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_BOX, TOOLBAR_DROPDOWN } from '@editor/src/img/pageIndex';
import {
    wrapIdForBig, wrapIdForTableTabInput,
    wrapIdForText,
} from '@framework/workbench/util/wrap-id-util';
import { TDWActionType, TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.BORDERSTYLE,
    tipMsg: i18n.t('边框格式'),
    title: i18n.t('边框格式'),
    icon: TOOLBAR_BOX,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 5,
        data: getBorderStyleData(),
    },
    twdConfig: {
        module: TDWModuleType.PC_TOOLBAR_FORM,
        action: TDWActionType.BORDERS,
        notReportVer5: true,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        hasArrow: true,
    },
    {
        name: wrapIdForText(config.id),
        hasArrow: true,
        text: i18n.t('边框格式'),
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
        },
    },
    {
        name: wrapIdForTableTabInput(config.id),
        hasArrow: true,
        text: i18n.t('边框线'),
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
        },
    },
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: config.title,
        tooltip: config.tipMsg,
        style: {
        },
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        style: {
            width: '232px',
            overflow: 'hidden',
            padding: 0,
            height: 'auto',
        },
        preventHighlight: true,
    },
    {
        name: config.id + 1,
        content: i18n.t<string>('边框格式'),
    },
];
